import type { CityConfig } from "../city-template/types";

export const farmingtonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Farmington",
  state: "New Mexico",
  stateAbbr: "NM",
  slug: "farmington",
  route: "/farmington",
  title: "Emergency Passport Farmington, NM — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Farmington, NM — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving San Juan County energy workers, Four Corners families, Navajo Nation travelers, and Northwest New Mexico residents.",
  h1: "Emergency & Expedited Passport Services in Farmington, NM",
  heroSubtitle: "Oil and gas business trip to Calgary in a week? Family vacation booked and your passport expired? Four Corners road trip turning into an international adventure? We help Farmington residents — from San Juan Basin energy workers to Aztec and Bloomfield families to Four Corners explorers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20panoramic%20view%20of%20Farmington%20New%20Mexico%20with%20the%20San%20Juan%20River%20winding%20through%20high%20desert%20landscape%2C%20the%20Bisti%20Badlands%20badlands%20visible%20in%20the%20distance%20under%20a%20dramatic%20sunset%20sky%2C%20red%20rock%20formations%20and%20mesa%20terrain%2C%20warm%20golden%20hour%20light%20across%20the%20Four%20Corners%20region%2C%20professional%20landscape%20photography%20with%20rich%20desert%20earth%20tones%20and%20brilliant%20sky%20colors&width=1800&height=700&seq=farmington-hero-2026&orientation=landscape",
  heroImageAlt: "Farmington New Mexico along the San Juan River with red rock landscape at golden sunset",
  geoPosition: "36.7281;-108.2187",
  geoPlacename: "Farmington, New Mexico",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "The nearest regional passport agency is the Denver Passport Agency in Aurora, CO — approximately 360 miles northeast. Appointments required, typically booked 2+ weeks out.",
  },
  nearbyCitiesZips: [
    { name: "Farmington", zips: "87401, 87402, 87499" },
    { name: "Aztec", zips: "87410" },
    { name: "Bloomfield", zips: "87413" },
    { name: "Kirtland", zips: "87417" },
    { name: "Flora Vista", zips: "87415" },
    { name: "Shiprock", zips: "87420" },
    { name: "Durango, CO", zips: "81301, 81302" },
    { name: "Gallup", zips: "87301" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Four Corners Emergency Processing", desc: "Reserved courier access — as fast as 24 hours for Farmington-area travelers with immediate departures. No driving to Aurora required." },
    { icon: "ri-oil-line", title: "Energy Industry Ready", desc: "San Juan Basin energy professionals travel internationally for conferences, training, and supplier meetings. We handle oil, gas, and renewable energy sector passport needs." },
    { icon: "ri-flight-takeoff-line", title: "Four Corners Regional Airport Access", desc: "Farmington's regional airport connects to Denver and Phoenix for international gateways. We coordinate around FMN departures and ABQ connections." },
    { icon: "ri-earth-line", title: "Navajo Nation & Four Corners Service", desc: "We serve the entire Four Corners region including Navajo Nation communities, with culturally aware service for extended family passport needs." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albuquerque, NM", route: "/albuquerque" },
    { name: "Expedited passport in Santa Fe, NM", route: "/santa-fe" },
    { name: "Expedited passport in Durango, CO", route: "/durango" },
    { name: "New Mexico passport services overview", route: "/new-mexico" },
  ],
  fpcOfficeAddress: "Serving Farmington via secure registered courier with direct agency access",
  fpcOfficeNote: "Fast Passport Center serves Farmington via secure registered courier with direct access to passport agencies. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Farmington residents can ship from any UPS Store, FedEx Office, or post office location across San Juan County and the Four Corners region.",
  fpcOfficeDistance: "Serving Farmington, Aztec, Bloomfield, Kirtland, Flora Vista, Shiprock, and all San Juan County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Farmington and the greater Four Corners region. From downtown Farmington and the Animas Valley Mall area to the San Juan College corridor — we serve all of San Juan County and northwestern New Mexico. Our courier service eliminates the need to drive to a distant passport agency in Aurora.",
  nearbyCitiesIntro: "We serve Farmington and all surrounding communities including Aztec, Bloomfield, Kirtland, Flora Vista, Shiprock, and the broader Four Corners area. We also serve travelers across the Colorado border in Durango and Cortez who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Farmington as simple as possible — with the efficiency and reliability San Juan Basin energy workers, Four Corners families, and San Juan College students need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Farmington travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Farmington travelers encounter unique passport issues — everything from the extreme distance to passport agencies to energy-sector short-notice business trips. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Farmington travelers — from San Juan Basin energy workers to Four Corners families to Navajo Nation residents — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Farmington, NM? Here are the most common ones we hear from San Juan County-area travelers.",
  statePageRoute: "/states/new-mexico",
  statePageName: "New Mexico",
  servicesIntro: "Whether you need a renewal before a Denver connection, an emergency passport for a last-minute energy conference, or a first-time passport for an extended family trip — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.sjcounty.net/departments/assessor/",
  dmvLabel: "San Juan County Assessor — Motor Vehicle Information",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Requires travel to Aurora, CO (360 miles) — essentially a full-day trip"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Energy conference in Calgary in two days? Family emergency requiring international travel? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Farmington-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Farmington residents renew fast — no agency visit required for most renewals. Perfect for San Juan Basin professionals and Four Corners families preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Farmington residents through every step — from downtown to San Juan College — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Denver connection or international trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Four Corners family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent travel? Ideal for San Juan Basin energy executives, geologists, and contractors who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Four Corners travelers through the process so your itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Farmington NM", description: "Urgent passport processing for Farmington New Mexico travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Farmington NM", description: "Fast passport renewal for Farmington New Mexico residents with a previously-issued passport." },
    { name: "First-Time Passport Farmington NM", description: "New passport application services for Farmington New Mexico residents applying for their first passport." },
    { name: "Child Passport Farmington NM", description: "Minor passport services for Farmington NM families with children under 16." },
    { name: "Name Change Passport Farmington NM", description: "Passport name correction after marriage, divorce, or legal name changes for Farmington residents." },
    { name: "Second Passport Farmington NM", description: "Second passport services for San Juan Basin professionals and frequent travelers." },
  ],
  testimonials: [
    {
      name: "Tom H.",
      location: "Farmington (Energy Sector)",
      rating: 5,
      text: "I work in oil and gas exploration and got called to a conference in Calgary with 6 days notice. My passport had expired during a busy quarter. Fast Passport Center got it back in 3 days. My company was impressed with how fast it was handled.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Begay Family",
      location: "Kirtland",
      rating: 5,
      text: "We were planning a family trip to Mexico and realized three of us needed new passports. The process for the whole family was smooth — they walked us through child applications and adult renewals simultaneously. All arrived within 7 days.",
      service: "Family Passport Services",
    },
    {
      name: "Rebecca M.",
      location: "Farmington",
      rating: 5,
      text: "I'm a San Juan College nursing student accepted into a medical mission trip to Guatemala with just two weeks notice. They helped me get my first-ever passport in time. The checklist was clear and I never felt lost in the process.",
      service: "First-Time Passport",
    },
    {
      name: "James D.",
      location: "Aztec",
      rating: 5,
      text: "Needed a second passport for visa processing while traveling regularly to Canada for energy sector work. They handled it efficiently and I never missed a business trip. Professional and reliable service.",
      service: "Second Passport",
    },
  ],
  facilities: [
    {
      id: "fm-1",
      name: "Farmington Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2301 E 20th St",
      city: "Farmington",
      state: "NM",
      zip: "87401",
      phone: "(505) 325-3221",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Farmington — San Juan County",
      website: "https://tools.usps.com/find-location.htm?location=1367541",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Farmington and San Juan County. Passport photos available on-site. Serves all Four Corners communities. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "fm-2",
      name: "Aztec Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Main Ave",
      city: "Aztec",
      state: "NM",
      zip: "87410",
      phone: "(505) 334-9511",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Aztec — San Juan County",
      website: "https://tools.usps.com/find-location.htm?location=1367084",
      websiteLabel: "USPS Location",
      notes: "Serves Aztec and eastern San Juan County. Smaller facility — call ahead to confirm hours and availability. Photo services may not be available — bring completed photos.",
      icon: "ri-mail-line",
    },
    {
      id: "fm-3",
      name: "Bloomfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1108 W Broadway Ave",
      city: "Bloomfield",
      state: "NM",
      zip: "87413",
      phone: "(505) 632-3311",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Bloomfield — San Juan County",
      website: "https://tools.usps.com/find-location.htm?location=1367101",
      websiteLabel: "USPS Location",
      notes: "Serves Bloomfield and south Farmington area. Limited hours — call ahead to confirm appointment availability. Photo services may not be available.",
      icon: "ri-mail-line",
    },
    {
      id: "fm-4",
      name: "San Juan County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "100 S Oliver Dr, Suite 200",
      city: "Aztec",
      state: "NM",
      zip: "87410",
      phone: "(505) 334-9471",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Aztec — San Juan County seat",
      website: "https://www.sjcounty.net/departments/county-clerk/",
      websiteLabel: "San Juan County Clerk",
      notes: "Official county clerk passport acceptance facility. No photo services on-site — bring completed passport photos. Serves all San Juan County residents. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "fm-5",
      name: "Durango Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "222 W 8th St",
      city: "Durango",
      state: "CO",
      zip: "81301",
      phone: "(970) 247-3211",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Durango, CO — 45 miles from Farmington",
      website: "https://tools.usps.com/find-location.htm?location=1367640",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility in Durango, CO. Convenient for Farmington residents heading north. Full photo services available. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "fm-6",
      name: "Gallup Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 S 2nd St",
      city: "Gallup",
      state: "NM",
      zip: "87301",
      phone: "(505) 722-6715",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Gallup — 90 miles south of Farmington",
      website: "https://tools.usps.com/find-location.htm?location=1367555",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for southern San Juan County residents. Photo services available. Convenient if traveling south on US-491.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, driving to Aurora (360 miles) required", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO (360 miles) — essentially a day-long trip", fpc: "Most Farmington travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle shipping, logistics, and 720-mile round trip to agency", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Four Corners Specific", agency: "Generic — no San Juan Basin, energy sector, or Four Corners expertise", fpc: "Full energy sector/Four Corners/regional knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Underestimating Distance to Passport Agencies",
      description: "Farmington is 360 miles from the nearest passport agency in Aurora, CO. Many residents do not realize how far away in-person agency services actually are. Our courier channel brings agency access to you — no road trip required.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Farmington applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Energy Sector Short-Notice International Travel",
      description: "San Juan Basin energy workers often get short-notice travel for international conferences, training, and supplier meetings. Expired or expiring passports discovered at the last minute create emergencies we are built to handle.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Rural-area photo services can produce substandard passport photos. We catch non-compliant photos during document review before they cause State Department rejections.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Regional Airport Connections",
      description: "Farmington travelers often fly through Denver or Phoenix for international connections. A passport issue discovered at FMN or DRO cascades quickly — a missed connection can derail an entire itinerary.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Farmington clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Aurora, CO." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Farmington?", a: "We offer Farmington-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Is there a passport agency near Farmington?", a: "No. The closest passport agency is the Denver Passport Agency in Aurora, CO — approximately 360 miles away (a 6+ hour drive each way). Our registered courier service is the fastest, most practical channel for Farmington residents." },
    { q: "Where can I get passport acceptance in Farmington?", a: "Farmington has acceptance at the Main Post Office on East 20th Street, the Aztec Post Office, Bloomfield Post Office, and the San Juan County Clerk in Aztec. We maintain an updated list of facilities with hours and photo availability." },
    { q: "Which airport do Farmington travelers use for international flights?", a: "Farmington residents typically fly from Four Corners Regional Airport (FMN) to Denver (DEN) or Phoenix (PHX) for international connections. Some drive to Albuquerque Sunport (ABQ) — about 180 miles south — for more direct international options." },
    { q: "What documents do Farmington applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Farmington-specific checklist." },
    { q: "Can you help energy sector workers with urgent business travel?", a: "Yes. The San Juan Basin is a major energy production region, and we regularly assist oil, gas, and renewable energy professionals with short-notice international travel for conferences, training, and supplier meetings across Canada, Europe, and the Middle East." },
    { q: "How do I check my passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Farmington to final return shipping typically matches your chosen speed tier." },
    { q: "What is the best price for expedited passport service in Farmington?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Is Farmington near the Four Corners Monument?", a: "Yes — Farmington is about 70 miles from the Four Corners Monument, where New Mexico, Arizona, Utah, and Colorado meet. The region's unique geography means residents often cross state lines for services, including passport acceptance facilities in Durango, CO." },
    { q: "How do I get a passport photo in Farmington?", a: "Passport photos are available at several Farmington locations including Walgreens, CVS, Walmart, and the UPS Store. The Main Post Office also offers photo services. We recommend confirming photo standards compliance before visiting." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Farmington Residents",
    intro: "Farmington's position at the heart of the San Juan Basin and the Four Corners region creates unique travel dynamics distinct from the rest of New Mexico. Here's what Farmington travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "FMN — Four Corners Regional Airport",
        subtitle: "Farmington's hometown airport with Denver and Phoenix connections",
        description: "Four Corners Regional Airport is serviced by United Express to Denver and American Eagle to Phoenix — both major international connecting hubs. For Farmington residents, the convenience of a local departure is balanced against the need to have passports ready before heading to the airport. A passport issue discovered at FMN means a missed connection at DEN or PHX with no same-day alternatives.",
        tip: "Check your passport validity before booking any flight from FMN. The connection at DEN or PHX is where your international journey really begins — and that is where passport problems cascade.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "DRO — Durango-La Plata County Airport",
        subtitle: "45 miles north, alternative regional departure",
        description: "Durango Airport, about 45 miles from Farmington, serves Four Corners residents with flights to Denver, Phoenix, and Dallas. Some Farmington residents choose DRO for better schedules or pricing. As with FMN, passport issues discovered at departure create missed-connection problems.",
        tip: "DRO offers flights to DFW via American Eagle — a direct path to one of the world's largest international hubs. Your passport needs to be ready before you leave Farmington.",
      },
      {
        icon: "ri-oil-line",
        title: "San Juan Basin Energy Industry Travel",
        subtitle: "Oil, gas, and renewable energy international business",
        description: "The San Juan Basin is one of the most productive natural gas regions in the United States and a growing center for renewable energy. Energy professionals based in Farmington regularly travel to Canada (Calgary, Edmonton), the Middle East (energy conferences), and Europe (supplier meetings and technology exchanges). These trips are frequently scheduled with 1–2 weeks notice.",
        tip: "Energy sector professionals should maintain current passports year-round. Industry conferences and supplier meetings in Calgary, Dubai, and Aberdeen rarely accommodate standard 8–11 week passport processing timelines.",
      },
      {
        icon: "ri-earth-line",
        title: "Four Corners Cross-Border & Cultural Travel",
        subtitle: "Navajo Nation, Ute Mountain Ute, and multi-state regional travel",
        description: "The Four Corners region is culturally rich with Navajo Nation, Ute Mountain Ute, Southern Ute, and Jicarilla Apache communities. International travel for cultural exchanges, indigenous rights conferences, and family visits to Mexico creates regular passport needs. Extended families often need multiple passports simultaneously.",
        tip: "For extended family applications — grandparents, parents, and children — plan additional time. We provide a family coordinator to manage multiple applications on a single timeline.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Farmington & Multi-State Service Access",
      description: "Farmington's Four Corners location means residents regularly access services in Colorado (Durango, Cortez), Arizona, and Utah. We treat the entire Four Corners region as one service area — you can use acceptance facilities and shipping locations in any of the four states and we coordinate the entire process from your Farmington home base.",
    },
  },
  destinations: {
    title: "Where Farmington Travelers Go — And Why Passports Get Urgent",
    intro: "Farmington's position as the economic center of the Four Corners and San Juan Basin creates travel patterns unique in New Mexico. Here are the most common international destinations.",
    stats: [
      { stat: "35%", label: "of Farmington expedited requests are energy sector or industrial business travel" },
      { stat: "2–3 Weeks", label: "average lead time from trip booking to departure for Four Corners travelers" },
      { stat: "Apr–Sep", label: "peak season — summer vacation, energy conferences, and outdoor recreation tourism overlap" },
      { stat: "48 Hours", label: "shortest turnaround for a Farmington energy executive departing to Canada" },
    ],
    destinations: [
      { name: "Canada", context: "Calgary and Edmonton energy sector, Alberta oil sands conferences, Vancouver connections", urgency: "Energy business travel often has 1–2 week notice", icon: "ri-map-pin-2-line" },
      { name: "Mexico", context: "Cancun and Riviera Maya family vacations, heritage visits, spring break destinations", urgency: "Spring break bookings peak January through March", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Germany", context: "Energy technology conferences, European supplier meetings, industrial equipment training", urgency: "Conference and training dates are fixed and unmovable", icon: "ri-map-pin-2-line" },
      { name: "Middle East", context: "Oil and gas industry conferences in Dubai and Abu Dhabi, energy sector networking", urgency: "Industry events have rigid dates with 2–3 week booking windows", icon: "ri-map-pin-2-line" },
      { name: "Caribbean", context: "Cruise departures, resort vacations, honeymoon destinations", urgency: "Cruise bookings often 3–4 weeks out with non-refundable deposits", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Energy technology exchanges, industrial equipment suppliers, San Juan College partnerships", urgency: "Supplier visits and technology training have rigid scheduling", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New Mexico Service Areas",
    crossLinksDesc: "We serve travelers across the Land of Enchantment with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Albuquerque", route: "/albuquerque" },
      { name: "Santa Fe", route: "/santa-fe" },
      { name: "Durango, CO", route: "/durango" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Farmington", address: "3500 E Main St, Farmington, NM 87402", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Farmington", address: "4900 E Main St, Farmington, NM 87402", hours: "Daily 8 AM – 10 PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walmart — Farmington", address: "4600 E Main St, Farmington, NM 87402", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/store/finder" },
    { name: "The UPS Store — Farmington", address: "3030 E Main St, Farmington, NM 87402", hours: "Call for hours", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "FedEx Office — Durango", address: "1125 S Camino Del Rio, Durango, CO 81303", hours: "Call for hours", website: "https://www.fedex.com/en-us/location.html" },
    { name: "Walgreens — Durango", address: "2707 Main Ave, Durango, CO 81301", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/storelocator" },
  ],
  dmvLocations: [
    {
      name: "San Juan County MVD — Farmington",
      address: "100 S Oliver Dr, Aztec, NM 87410",
      hours: "Mon–Fri, 8:00 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Located at the County complex in Aztec. Appointment recommended.",
      featured: true,
    },
    {
      name: "New Mexico MVD — Farmington Field Office",
      address: "3501 E Main St, Farmington, NM 87402",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full-service MVD office. REAL ID available. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FMN",
      name: "Four Corners Regional Airport",
      distance: "About 3 miles from downtown Farmington",
      address: "1000 W Navajo St, Farmington, NM 87401",
      note: "Farmington's regional airport with United Express service to Denver (DEN) and American Eagle to Phoenix (PHX) — both major international connecting hubs.",
      flightUrl: "https://www.fmtn.org/271/Four-Corners-Regional-Airport",
      flightLabel: "FMN Airport Website",
      featured: true,
    },
    {
      code: "DRO",
      name: "Durango-La Plata County Airport",
      distance: "About 45 miles north of Farmington",
      address: "1000 Airport Rd, Durango, CO 81303",
      note: "Alternative regional airport with flights to Denver, Phoenix, and Dallas (DFW). About a 50-minute drive from Farmington through the San Juan River valley.",
      flightUrl: "https://www.flydurango.com/",
      flightLabel: "DRO Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New Mexico Department of Health. Online, mail, or in-person options available for San Juan County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NM Department of Health Vital Records. Required for estate and legal matters in San Juan County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the San Juan County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.sjcounty.net/departments/county-clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the 11th Judicial District Court. Required for name change passport corrections.",
      url: "https://eleventhdistrictcourt.nmcourts.gov/",
    },
  ],
};